import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

export default class Sliders {

  offer() {
    new Swiper(".offer-slider", {
      loop: true,
      autoHeight: true,
      preloadImages: false,
      lazy: true,
      // navigation: {
      //   nextEl: '.products-slider-next',
      // },
      autoplay: {
  			delay: 5000,
  		},
    });
  }

  products() {

    // $('.products-slider').each(function(index) {

    //   // var $nav = $(this).parent().find('.product-slider-nav');
    //   // var nav_next_class = "product-next-" + index;
    //   // var nav_prev_class = "product-prev-" + index;

    //   // $nav.find('.product-slider-nav-next').addClass(nav_next_class);
    //   // $nav.find('.product-slider-nav-prev').addClass(nav_prev_class);
      
    //   new Swiper($(this)[0], {
    //     slidesPerView: 4,
    //     spaceBetween: 10,
    //     preloadImages: false,
    //     lazy: true,
    //   });

    // });

    

    document.querySelectorAll('.products-slider').forEach((slider) => {
      const container = slider.closest('.products-slider-container');

      new Swiper(slider, {
        slidesPerView: 2,
        spaceBetween: 30,
        preloadImages: false,
        lazy: false,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: container ? container.querySelector('.products-slider-next') : null,
          prevEl: container ? container.querySelector('.products-slider-prev') : null,
        },
        breakpoints: {
          576: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 30,
          }
        }
      });
    });

  }


  news() {

      new Swiper(".news-slider", {
        loop: true,
        slidesPerView: 1,
        //autoHeight: true,
        preloadImages: false,
        lazy: true,
        navigation: {
          nextEl: '.news-slider-next',
          prevEl: '.news-slider-prev',
        },
        autoplay: {
    			delay: 5000,
    		},
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 40,
          },
          992: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1360: {
            slidesPerView: 3,
            spaceBetween: 80,
          },
        }
      });
  }

    gallery() {

      new Swiper(".gallery-slider", {
        loop: false,
        autoHeight: false,
        preloadImages: false,
        lazy: true,
        slidesPerView: 1,
        spaceBetween: 50,
        navigation: {
					nextEl: '.gallery-slider-next',
          prevEl: '.gallery-slider-prev',
				},
        // autoplay: {
		// 			delay: 5000,
		// 		},
      });

    }

  
    init() {
      document.querySelector('.products-slider') ? this.products() : null;
      document.querySelector('.gallery-slider') ? this.gallery() : null;
    }
}
